import { useState, useEffect, useRef } from "react";
import "./AllChecklist.scss"
import axios from "axios";
import WebService from "../utility/WebService";
import Header from "../Header/Header";
import { toast } from "react-toastify";
import invoiceImage from '../assets/images/OnInvoice.jpg';
import Loader from "../Loader/Loader";
import Footer from "../Footer/Footer";
import Accordion from 'react-bootstrap/Accordion';
import { CheckCircleFill, PencilFill, PrinterFill } from "react-bootstrap-icons";
import { Form } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import HelperService from "../utility/HelperService";
import phoneIcon from '../assets/images/phone.svg';
import mailIcon from '../assets/images/mail.svg';

const AllCheckList = () => {
    const [isLoading, setLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState<any>({});
    const [companyCode, setCompanyCode] = useState<any>();
    const [invoiceNum, setInvoiceNum] = useState<any>();
    const [isShowInvoice, setIsShowInvoice] = useState(false)
    const [otherData, setOtherData] = useState<any>()
    const [id, setId] = useState<any>()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = urlParams.get('token')
    const [taskData, setTaskData] = useState<any>([])
    const [detailData, setDetailData] = useState<any>()
    const [isShowEditModel, setShowEditModel] = useState(false)
    const [editData, setEditData] = useState<any>()
    const [selectedTaskList, setSelectedTaskList] = useState<any>();
    const [activeSessions, setActiveSessions] = useState<any>([]);
    const [isShowInternal, setShowInternal] = useState(false)
    const componentRef = useRef<any>();

    useEffect(() => {
        if (value) {
            setId(value)
            getAccessToken()
        } else {
            setId('')
        }
    }, [])

    const getAccessToken = () => {
        localStorage.clear();
        setLoading(true)
        axios.get(`${WebService.getUrl()}admin/Auth/verify-sawinToken?id=${value && encodeURIComponent(value)}`)
            .then((res: any) => {
                setLoading(false)
                if (res.data.status == 'Error') {
                    toast.error(res.data.message)
                    setIsShowInvoice(false)
                }
                if (res.data.accessToken) {
                    setOtherData(res.data)
                    getInvoiceData(res.data.accessToken, res.data.companyCode, res.data.invoiceNumber, res.data.tenantUrl)
                    setInvoiceNum(res.data.invoiceNumber)
                    setCompanyCode(res.data.companyCode)
                    setShowInternal(res.data.taskListForCustomer)
                    localStorage.setItem('token', res.data.accessToken)
                    localStorage.setItem('tenant_url', res.data.tenantUrl)
                }
            })
            .catch((e) => {
                setId('')
                setIsShowInvoice(false)
                setLoading(false);
            })
    };

    const getInvoiceData = (token: string, code: string, invoice: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        setLoading(true)
        axios.get(`${url}/api/Invoice/customerInvoiceInfo?CompanyCode=${code}&InvoiceNumber=${invoice}&InitialLoad=true`, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    getChecklist(code, invoice)
                    getMoreData(token, code, invoice, url)
                    setIsShowInvoice(true)
                    res.data.data.callInfo.invoiceNum = invoice;
                    setInvoiceData(res.data.data);
                }
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getMoreData = (token: string, code: string, invoice: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        axios.get(`${url}/api/Invoice/customerInvoiceInfo?CompanyCode=${code}&InvoiceNumber=${invoice}`, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    setIsShowInvoice(true)
                    res.data.data.callInfo.invoiceNum = invoice;
                    setInvoiceData(res.data.data);
                }
            })
            .catch((e) => {
            });
    };

    const getChecklist = (code: string, invoice: string) => {
        //"1552"
        WebService.postAPI({
            action: `api/Invoice/tasklistNew`,
            body: {
                companyCode: code,
                invoiceNumber: invoice,
                isExternal: true
            }
        })
            .then((res: any) => {
                var externalData = [];
                var internalData = [];
                for (var j in res.data) {
                    for (var k in res.data[j].values) {
                        for (var l in res.data[j].values[k].list) {
                            if (res.data[j].values[k].list[l].selectedValue != null) {
                                if (res.data[j].values[k].list[l].selectedValue.value != null && res.data[j].values[k].list[l].selectedValue.value != "") {
                                    res.data[j].values[k].list[l].selectedValue.selectedValue = res.data[j].values[k].list[l].selectedValue.value
                                }
                                if (res.data[j].values[k].list[l].selectedValue.value != null && res.data[j].values[k].list[l].selectedValue.value != "") {
                                    res.data[j].values[k].list[l].selectedValue.selectedValue = res.data[j].values[k].list[l].selectedValue.value
                                }
                            }
                        }
                    }
                }
                for (var i in res.data) {
                    if (res.data[i].isExternal) {
                        externalData.push(res.data[i])
                    } else {
                        internalData.push(res.data[i])
                    }
                }
                res.data.internalData = internalData
                res.data.externalData = externalData
                setTaskData(res.data)
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
            })
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const onPrint = () => {
        for (var i in taskData) {
            activeSessions.push(taskData[i].id)
        }
        setActiveSessions([...activeSessions])
        const timer = setTimeout(() => {
            handlePrint()
        }, 1000);
        return () => clearTimeout(timer);
    }

    return <>
        <div>
            <Loader show={isLoading} />
            <Header isCheckList={true} title={'SAWIN - CheckList'} />
            {/* <div className="checklist-woNum">{invoiceData?.callInfo?.woNum}</div>x */}
            <span className="cursor-pointer d-flex justify-content-end mt-4 me-4" onClick={() => {
                onPrint()
            }}>
                <PrinterFill size={20} />
            </span>
            <div ref={componentRef} style={{ marginBottom: 100 }}>
                <div className="d-flex justify-content-between mt-2">
                    <div className="ms-3">
                        <div className="text-center">{invoiceData?.companyInfo?.companyName}</div>
                        <div className="text-center">{invoiceData?.callInfo?.woNum}</div>
                        {/* <div className="text-center">{invoiceData?.companyInfo?.companyCity} {invoiceData?.companyInfo?.companyState && ', ' + invoiceData?.companyInfo?.companyState} {invoiceData?.companyInfo?.companyZip && ", " + invoiceData?.companyInfo?.companyZip}</div> */}
                        {/* {
                            invoiceData?.location?.smPhone && <div className="address-text text-center">
                                <img src={phoneIcon} className="me-2" />
                                {HelperService.getFormattedContact(invoiceData?.location?.smPhone)}</div>
                        }
                        {
                            invoiceData?.location?.defaultEMail && <div className="address-text text-center">
                                <img src={mailIcon} className="me-2" />
                                {invoiceData?.location?.defaultEMail}</div>
                        } */}
                    </div>
                    <div className="me-3">
                        <div className="text-center">{invoiceData?.location?.smNum} {invoiceData?.location?.smName}</div>
                        <div className="text-center">{invoiceData?.location?.address1}</div>
                        <div className="text-center">{invoiceData?.location?.address2}</div>
                        <div className="text-center">{invoiceData?.location?.city} {invoiceData?.location?.city} {invoiceData?.location?.state && ', ' + invoiceData?.location?.state} {invoiceData?.location?.zip && ", " + invoiceData?.location?.zip}</div>
                        {
                            invoiceData?.location?.smPhone && <div className="address-text text-center">
                                <img src={phoneIcon} className="me-2" />
                                {HelperService.getFormattedContact(invoiceData?.location?.smPhone)}</div>
                        }
                        {
                            invoiceData?.location?.defaultEMail && <div className="address-text text-center">
                                <img src={mailIcon} className="me-2" />
                                {invoiceData?.location?.defaultEMail}</div>
                        }
                    </div>
                </div>
                {
                    isShowInvoice &&
                    <>

                        <Accordion activeKey={activeSessions} className='accordian p-3' alwaysOpen>
                            {isShowInternal && <div className="title">External:</div>}
                            {
                                taskData.externalData && taskData.externalData.length > 0 && taskData.externalData.map((res: any, index: number) => {
                                    return (
                                        <Accordion.Item eventKey={res.id} className='accordian-item' onClick={() => {
                                            var value = activeSessions.includes(res.id);
                                            if (!value) {
                                                activeSessions.push(res.id)
                                                setActiveSessions([...activeSessions])
                                            } else {
                                                var newArray = activeSessions.filter((value: any) => value != res.id);
                                                setActiveSessions(newArray)
                                            }
                                        }}>
                                            <Accordion.Header>
                                                {res.headerName}
                                            </Accordion.Header>
                                            <Accordion.Body>

                                                <div className="d-flex row col-12">

                                                    {
                                                        res.values && res.values.length > 0 && res.values.map((response: any) => {
                                                            return (
                                                                <>

                                                                    {
                                                                        response.list && response.list.map((val: any) => {
                                                                            var value = ''
                                                                            if (val.typeId == 'CAPTURE_SIGNATURE') {
                                                                                var check = val.selectedValue?.selectedValue?.includes('data:image/png;base64,')
                                                                                if (check) {
                                                                                    value = val.selectedValue?.selectedValue.replace('data:image/png;base64,', '')
                                                                                } else {
                                                                                    value = 'data:image/png;base64,' + val.selectedValue?.selectedValue
                                                                                }
                                                                            }
                                                                            return (
                                                                                <>
                                                                                    {
                                                                                        ((val.selectedValue?.selectedValue != null && val.selectedValue?.selectedValue != '') || (val.selectedValueArray != null && val.selectedValueArray.length > 0)) &&
                                                                                        <>
                                                                                            <div className="col-12 p-2">
                                                                                                <div className="checklist-title text-truncate" title={val.name}>
                                                                                                    {val.name}
                                                                                                </div>
                                                                                                <div>
                                                                                                    {val.typeId == 'CAPTURE_SIGNATURE' ? <div>
                                                                                                        <img src={`${value}`} style={{ height: 150, width: 200 }} />
                                                                                                    </div>
                                                                                                        :
                                                                                                        val.typeId == 'SPOTLIGHT_CONTROL' ?
                                                                                                            <div className="d-flex">
                                                                                                                <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#c02525", opacity: val?.selectedValue?.selectedValue == 'RED' ? 10 : 0.5 }}>
                                                                                                                    {
                                                                                                                        val?.selectedValue?.selectedValue == 'RED' ?
                                                                                                                            <CheckCircleFill color="white" size={13} />
                                                                                                                            :
                                                                                                                            <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'RED' ? true : false} name="name" />
                                                                                                                    }
                                                                                                                </Form.Group>
                                                                                                                <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#c0a925", opacity: val?.selectedValue?.selectedValue == 'YELLOW' ? 10 : 0.5 }}>
                                                                                                                    {
                                                                                                                        val?.selectedValue?.selectedValue == 'YELLOW' ?
                                                                                                                            <CheckCircleFill color="white" size={13} />
                                                                                                                            :
                                                                                                                            <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'YELLOW' ? true : false} name="name" />
                                                                                                                    }
                                                                                                                </Form.Group>
                                                                                                                <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#438e23", opacity: val?.selectedValue?.selectedValue == 'GREEN' ? 10 : 0.5 }}>
                                                                                                                    {
                                                                                                                        val?.selectedValue?.selectedValue == 'GREEN' ?
                                                                                                                            <CheckCircleFill color="white" size={13} />
                                                                                                                            :
                                                                                                                            <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'GREEN' ? true : false} name="name" />
                                                                                                                    }
                                                                                                                </Form.Group>
                                                                                                            </div>
                                                                                                            :
                                                                                                            val.selectedValue?.selectedValue}
                                                                                                    {val.typeId == 'UPLOAD_IMAGE' &&
                                                                                                        <div>
                                                                                                            {
                                                                                                                val.selectedValueArray && val.selectedValueArray.length > 0 && val.selectedValueArray.map((val: any) => {
                                                                                                                    return (
                                                                                                                        <img src={val?.documentThumbUrl} style={{ height: 50, width: 50 }} />
                                                                                                                    )
                                                                                                                })
                                                                                                            }

                                                                                                        </div>
                                                                                                    }
                                                                                                    <div className="d-flex row" style={{ marginLeft: -4 }}>
                                                                                                        {
                                                                                                            val.selectedValueArray && val.selectedValueArray.length > 0 && val.selectedValueArray.map((response: any, i: any) => {
                                                                                                                return (
                                                                                                                    <div className="w-auto p-1">{i == val.selectedValueArray.length - 1 ? response.name != null && response.name : response.name != null && (response.name + ' ,')}</div>
                                                                                                                )
                                                                                                            })
                                                                                                        }
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )
                                })
                            }
                            {
                                isShowInternal &&
                                <>
                                    <div className="title mt-3">Internal:</div>
                                    {
                                        taskData.internalData && taskData.internalData.length > 0 && taskData.internalData.map((res: any, index: number) => {
                                            return (
                                                <Accordion.Item eventKey={res.id} className='accordian-item' onClick={() => {
                                                    var value = activeSessions.includes(res.id);
                                                    if (!value) {
                                                        activeSessions.push(res.id)
                                                        setActiveSessions([...activeSessions])
                                                    } else {
                                                        var newArray = activeSessions.filter((value: any) => value != res.id);
                                                        setActiveSessions(newArray)
                                                    }
                                                    setSelectedTaskList(res.id)
                                                    // getTaskListDetail(res.id, index)
                                                }}>
                                                    <Accordion.Header>
                                                        {res.headerName}
                                                    </Accordion.Header>
                                                    <Accordion.Body>

                                                        <div className="d-flex row col-12">

                                                            {
                                                                res.values && res.values.length > 0 && res.values.map((res: any) => {
                                                                    return (
                                                                        <>

                                                                            {
                                                                                res.list && res.list.map((val: any) => {
                                                                                    var value = ''
                                                                                    if (val.typeId == 'CAPTURE_SIGNATURE') {
                                                                                        var check = val.selectedValue?.selectedValue?.includes('data:image/png;base64,')
                                                                                        if (check) {
                                                                                            value = val.selectedValue?.selectedValue.replace('data:image/png;base64,', '')
                                                                                        } else {
                                                                                            value = 'data:image/png;base64,' + val.selectedValue?.selectedValue
                                                                                        }
                                                                                    }
                                                                                    return (
                                                                                        <>
                                                                                            {
                                                                                                ((val.selectedValue?.selectedValue != null && val.selectedValue?.selectedValue != '') || (val.selectedValueArray != null && val.selectedValueArray.length > 0)) &&
                                                                                                <>
                                                                                                    <div className="col-12 p-2">
                                                                                                        <div className="checklist-title text-truncate" title={val.name}>
                                                                                                            {val.name}
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            {val.typeId == 'CAPTURE_SIGNATURE' ? <div>
                                                                                                                <img src={`${value}`} style={{ height: 150, width: 200 }} />
                                                                                                            </div>
                                                                                                                :
                                                                                                                val.typeId == 'SPOTLIGHT_CONTROL' ?
                                                                                                                    <div className="d-flex">
                                                                                                                        <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#c02525", opacity: val?.selectedValue?.selectedValue == 'RED' ? 10 : 0.5 }}>
                                                                                                                            {
                                                                                                                                val?.selectedValue?.selectedValue == 'RED' ?
                                                                                                                                    <CheckCircleFill color="white" size={13} />
                                                                                                                                    :
                                                                                                                                    <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'RED' ? true : false} name="name" />
                                                                                                                            }
                                                                                                                        </Form.Group>
                                                                                                                        <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#c0a925", opacity: val?.selectedValue?.selectedValue == 'YELLOW' ? 10 : 0.5 }}>
                                                                                                                            {
                                                                                                                                val?.selectedValue?.selectedValue == 'YELLOW' ?
                                                                                                                                    <CheckCircleFill color="white" size={13} />
                                                                                                                                    :
                                                                                                                                    <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'YELLOW' ? true : false} name="name" />
                                                                                                                            }
                                                                                                                        </Form.Group>
                                                                                                                        <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#438e23", opacity: val?.selectedValue?.selectedValue == 'GREEN' ? 10 : 0.5 }}>
                                                                                                                            {
                                                                                                                                val?.selectedValue?.selectedValue == 'GREEN' ?
                                                                                                                                    <CheckCircleFill color="white" size={13} />
                                                                                                                                    :
                                                                                                                                    <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'GREEN' ? true : false} name="name" />
                                                                                                                            }
                                                                                                                        </Form.Group>
                                                                                                                    </div>
                                                                                                                    :
                                                                                                                    val.selectedValue?.selectedValue}
                                                                                                            {val.typeId == 'UPLOAD_IMAGE' &&
                                                                                                                <div>
                                                                                                                    {
                                                                                                                        val.selectedValueArray && val.selectedValueArray.length > 0 && val.selectedValueArray.map((val: any) => {
                                                                                                                            return (
                                                                                                                                <img src={val?.documentThumbUrl} style={{ height: 50, width: 50 }} />
                                                                                                                            )
                                                                                                                        })
                                                                                                                    }

                                                                                                                </div>
                                                                                                            }
                                                                                                            <div className="d-flex row" style={{ marginLeft: -4 }}>
                                                                                                                {
                                                                                                                    val.selectedValueArray && val.selectedValueArray.length > 0 && val.selectedValueArray.map((response: any, i: any) => {
                                                                                                                        return (
                                                                                                                            <div className="w-auto p-1">{i == val.selectedValueArray.length - 1 ? response.name : response.name + ' ,'}</div>
                                                                                                                        )
                                                                                                                    })
                                                                                                                }
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            )
                                        })
                                    }
                                </>
                            }
                        </Accordion>
                    </>
                }
            </div>
            {
                isShowInvoice == false && id == '' &&
                <div className="no-invoice-view">
                    <img src={invoiceImage} height={200} width={200} />
                    <span className="no-invoice">No Invoice Found!</span>
                </div>
            }
            <Footer data={otherData?.genericFooter} />
        </div>
    </>;
};

export default AllCheckList;


